import * as firebase from "firebase/app"
import "firebase/storage"
import AppService from "./app-service"

const path = "users"

export default class UserService extends AppService {

  constructor() {
    super({ path })
  }

  static get GROUPS() {
    return {
      admin: { icon: "cogs red icon" },
      employee: { icon: "users blue icon" },
      financial: { icon: "dollar sign green icon" },
      customer: { icon: "address card outline violet icon" },
      vet: { icon: "user md grey icon" },
    }
  }

  getUserSignature(userId) {
    return this.http.get(`${path}/${userId}/signature`) 
  }

  removeUserSignature(userId, image) {
    return firebase.storage().ref(`${path}/${userId}/signature`).child(image.name).delete()
  }

  getProfileUsers(profile) {
    return this.http.get(`profile-users?profile=${profile}`) 
  }

  findGroupUsers(groupId) {
    return this.http.get(`group-users?groupId=${groupId}`) 
  }

  findSimavetUsers() {
    return this.http.get(`${path}?onlySimavet=true`)
  }

  findMonthBirthDays() {
    return this.http.get("month-birthdays-users") 
  }
}